import { createContext, useContext } from "react";

// Provides a scrollToId(id) function powered by the Lenis instance.
export const ScrollContext = createContext({ scrollToId: () => {} });

export const useScrollTo = () => useContext(ScrollContext).scrollToId;
